import React from "react";
import handleDeepLink from "@/utils/handleDeepLink";
import clientDeepLinks from "@/utils/clientDeepLinks";
import { useRouter } from "next/router";
import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers } from "@/interfaces/enums";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import useInApp from "@/hooks/useIsApp";
import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";
import getDocBanner from "@/containers/docs/docBanner";
import { letterSpace } from "@/utils/localeUtils";
import DocContainer from "@/containers/docs/DocContainer";
import RFLayout from "@/layout/RFLayout";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { fetchCmsEduArticleBySlug } from "@/service/cms.service";

interface OptionDocProps {
	title: string;
	content: string;
	banner: string;
	description: string;
	slug: string;
	classN: string;
	bgImg: string;
}

export default function OptionDoc({ content, title, description, slug, classN, bgImg }: OptionDocProps) {
	const router = useRouter();
	const isInApp = useInApp();

	const handleBtnClick = () => {
		if (isInApp) {
			// 抄底宝
			if (slug === "better-buy") {
				handleDeepLink(clientDeepLinks.betterBuyOmnibus());
				return;
			}
			if (router.query.source) {
				handleDeepLink(clientDeepLinks.optiontab());
				return;
			}
			bridge.call(BridgeCallHandlers.ON_SLIDE_TO_TOP);
			bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
			return;
		}

		router.push("intents/download?deeplink=" + encodeURIComponent(clientDeepLinks.optiontab()));
	};

	const hiddenFooterBtn = () => {
		if (!isInApp) return true;
		return ["better-buy"].includes(slug);
	};

	return (
		<DocContainer
			title={title}
			description={description}
			banner={bgImg}
			hiddenFooterBtn={hiddenFooterBtn()}
			onFooterBtnClick={handleBtnClick}
			className={classN}
		>
			{content}
		</DocContainer>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { locale, params } = context;
	const slug = params?.slug as string;
	let classN = letterSpace(locale);

	try {
		const res = await fetchCmsEduArticleBySlug(slug, context.locale || "en");
		if (!res) throw new Error("No article found");
		return {
			props: {
				...(await serverSideTranslations(context.locale || "en", ["docs"])),
				...res,
				classN,
				slug,
				bgImg: getFullWebCdnUrl(getDocBanner(slug), false),
			},
		};
	} catch (error) {
		return {
			notFound: true,
		};
	}
};

OptionDoc.getLayout = function getLayout(page: ReactElement) {
	return <RFLayout>{page}</RFLayout>;
};
